// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledInlineGallery = styled('div')(
  () => css`
    .inline-image-gallery {
      .label {
        margin: 24px 0;
        font-style: normal;
        font-weight: 800;
        font-size: 1rem;
        display: block;
      }
      .container {
        background: #fcfcfc;
        border: 1px solid #f5f5f5;
        box-sizing: border-box;
        border-radius: 8px;
        justify-content: start;
        overflow: hidden;
        gap: 12px;
        padding: 16px;
        position: relative;
        flex-wrap: wrap;
        overflow: hidden;
        height: 135px;
        .more {
          left: 0;
          top: 0;
          bottom: 0;
          width: 65px;
          background: #fcfcfc;
          position: absolute;
          justify-content: center;
          .icon {
            background: #ffffff;
            border: 1px solid #eeeeee;
            box-sizing: border-box;
            border-radius: 6px;
            width: 36px;
            height: 36px;
            padding: 7px;
            cursor: pointer;
          }
        }
        .image {
          background: #ffffff;
          border: 1px solid #f5f5f5;
          box-sizing: border-box;
          border-radius: 8px;
          width: 104px;
          height: 104px;
          cursor: pointer;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
    }
  `
);
